import { generateState } from '../builder'

export default {
  characterTopologies: [],
  ...generateState('getCharacterTopologies'),
}
